import formatCurrency from "~/utils/formatCurrency";
import {defineNuxtPlugin} from "#app";

export default defineNuxtPlugin(nuxtApp => {
    nuxtApp.provide('currency', formatCurrency);
});
